import clsx from "clsx";

import { formatRemainingTime } from "../../../utils";

interface TimerDisplayProps {
  isRecording?: boolean;
  timer: number;
}

export default function TimerDisplay({
  isRecording = false,
  timer,
}: TimerDisplayProps) {
  return (
    <span
      className={clsx([
        "w-9 text-button-xs",
        isRecording ? "text-white" : "text-black-500",
      ])}
    >
      {formatRemainingTime(timer)}
    </span>
  );
}
